import React from 'react';
import LogoEme from '../img/_LogoEMEblack.svg';

// styles imports
import '../css/Footer.css';

// image imports


function Footer() {
  return (
    <div className='Footer'>
      <footer className="footer">
       
        <h2>¿Tienes un proyecto en mente? Concertemos una llamada y exploremos juntos cómo convertir tu idea en algo extraordinario.</h2>
       
        <div className='info'>
            <div className='contact_info'>
              <p>Hablemos</p>
              <p>hola@emedsgn.com</p>
            </div>
            <div className='credits'>
              <p>© 2026 — Emedsgn <br />
                Art Direction · Creative Direction · Visual Identity</p>
            </div>
        </div>

        <img 
          className='logo' 
          src= {LogoEme} alt="" 
        />

     </footer>
    </div>
  )
}

export default Footer;